(function(angular) {
    'use strict';

    angular.module('aprima-provider-api').factory('FncVisitInfoRepository', [
        'AprimaAnalytics',
        'AprimaRestangular',
        'MetadataRepository',
        FncVisitInfoRepository
    ]);

    function FncVisitInfoRepository(
        AprimaAnalytics,
        AprimaRestangular,
        MetadataRepository
    ) {
        var service = {
            create: createVisitInfo,
            save: saveVisitInfo,
            get: getVisitInfo,
            getMetadata: getVisitInfoMetadata,
        };

        return service;

        function createVisitInfo(visitInfo) {
            var timing = AprimaAnalytics.startTiming('FncRepository', 'api', 'createVisitInfo');
            var restangular = AprimaRestangular.get();
            return restangular
                .all('fnc/visit-info')
                .post(visitInfo)
                .finally(timing.stop);
        }

        function saveVisitInfo(visitInfo) {
            var timing = AprimaAnalytics.startTiming('FncRepository', 'api', 'saveVisitInfo');
            var restangular = AprimaRestangular.get();
            return restangular
                .all('fnc/visit-info')
                .customPUT(visitInfo)
                .finally(timing.stop);
        }

        function getVisitInfo(visitId) {
            var timing = AprimaAnalytics.startTiming('FncRepository', 'api', 'getVisitInfo');
            var restangular = AprimaRestangular.get();
            return restangular
                .one('fnc', visitId)
                .customGET('visit-info')
                .finally(timing.stop);
        }

        function getVisitInfoMetadata (scope) {
            var timing = AprimaAnalytics.startTiming('AppointmentRepository', 'api', 'getVisitInfoMetadata');
            return MetadataRepository.getMetadata('visit-info', scope).finally(timing.stop);
        }
    }
})(window.angular);
